/** Time-range chips of the search filter bar (Spec 120 E4). */
export const TIME_RANGE_KEYS = [
  'last30Days',
  'quarter',
  'halfYear',
  'thisYear',
  'lastYear',
] as const;
export type TimeRangeKey = (typeof TIME_RANGE_KEYS)[number];

// Local date parts, never toISOString(): that shifts the day with the timezone.
function iso(year: number, month: number, day: number): string {
  const d = new Date(year, month, day);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function timeRangeFor(key: TimeRangeKey, today: Date): { fromDate: string; toDate: string } {
  const y = today.getFullYear();
  const m = today.getMonth();
  switch (key) {
    case 'last30Days':
      return { fromDate: iso(y, m, today.getDate() - 29), toDate: iso(y, m, today.getDate()) };
    case 'quarter': {
      const start = m - (m % 3);
      return { fromDate: iso(y, start, 1), toDate: iso(y, start + 3, 0) };
    }
    case 'halfYear': {
      const start = m < 6 ? 0 : 6;
      return { fromDate: iso(y, start, 1), toDate: iso(y, start + 6, 0) };
    }
    case 'thisYear':
      return { fromDate: iso(y, 0, 1), toDate: iso(y, 11, 31) };
    case 'lastYear':
      return { fromDate: iso(y - 1, 0, 1), toDate: iso(y - 1, 11, 31) };
  }
}
